"use client";
import * as React from "react";
const SvgSpinnerRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.73 2a6.03 6.03 0 0 0-.87 12 1 1 0 0 1-.28 1.99A8.04 8.04 0 0 1 8.73 0a8 8 0 0 1 6.39 3.17 1 1 0 1 1-1.6 1.21 6 6 0 0 0-4.8-2.37", clipRule: "evenodd" }));
export {
  SvgSpinnerRound as default
};
